import { FormattedAxnAttributeLabel } from "@idw-types/data/reference-data/axn";

export enum AttributeLabelDetailsActionTypes {
    // Attribute Label Details
    SET_ATTRIBUTE_LABEL_DETAILS_LOADING = "SET_ATTRIBUTE_LABEL_DETAILS_LOADING",
    SET_ATTRIBUTE_LABEL_DETAILS = "SET_ATTRIBUTE_LABEL_DETAILS"
}

// Attribute Label Details
type SetAttributeLabelDetailsLoadingAction = {
    type: AttributeLabelDetailsActionTypes.SET_ATTRIBUTE_LABEL_DETAILS_LOADING,
    payload: { isLoading: boolean; }
};

export const setAttributeLabelDetailsLoading = (isLoading: boolean): SetAttributeLabelDetailsLoadingAction => ({
    type: AttributeLabelDetailsActionTypes.SET_ATTRIBUTE_LABEL_DETAILS_LOADING,
    payload: { isLoading }
});

type SetAttributeLabelDetailsAction = {
    type: AttributeLabelDetailsActionTypes.SET_ATTRIBUTE_LABEL_DETAILS,
    payload: { axnAttributeLabel: FormattedAxnAttributeLabel; }
}

export const setAttributeLabelDetails = (axnAttributeLabel: FormattedAxnAttributeLabel): SetAttributeLabelDetailsAction => ({
    type: AttributeLabelDetailsActionTypes.SET_ATTRIBUTE_LABEL_DETAILS,
    payload: { axnAttributeLabel }
});

export type AttributeLabelDetailsActions =
    // Attribute Label Details
    SetAttributeLabelDetailsLoadingAction |
    SetAttributeLabelDetailsAction